import { UserStatus } from "@/types";
import { ChipProps } from "@mui/material";

export const chipColorByStatus = (status: UserStatus): ChipProps["color"] => {
  switch (status) {
    case UserStatus.ACTIVE: {
      return "success";
    }

    default: {
      return "error";
    }
  }
};
